import { render, staticRenderFns } from "./mainPage.vue?vue&type=template&id=7c4a17b8&scoped=true"
import script from "./mainPage.vue?vue&type=script&lang=js"
export * from "./mainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4a17b8",
  null
  
)

export default component.exports